import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import ProfileSidebar from './ProfileSidebar';
import ProfilePersonalData from './ProfilePersonalData';
import ProfileOrders from './ProfileOrders';
import ProfileServices from './ProfileServices';
import ProfileDocuments from './ProfileDocuments';

import {
    PROFILE_SECTIONS,
    profileSelectors,
    profileActions,
    loadProfile,
} from '../../../features/profile';
import { logout } from '../../../features/auth/actions';

import './styles.css';

const ProfilePage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const activeSection = useSelector(profileSelectors.selectActiveSection);

    useEffect(() => {
        dispatch(loadProfile());
    }, [dispatch]);

    const handleSectionChange = (section) => {
        dispatch(profileActions.setActiveSection(section));
    };

    const handleLogout = () => {
        dispatch(logout());
        navigate('/');
    };

    const renderActiveSection = () => {
        switch (activeSection) {
            case PROFILE_SECTIONS.ORDERS:
                return <ProfileOrders />;
            case PROFILE_SECTIONS.SERVICES:
                return <ProfileServices />;
            case PROFILE_SECTIONS.DOCUMENTS:
                return <ProfileDocuments />;
            case PROFILE_SECTIONS.PERSONAL_DATA:
            default:
                return <ProfilePersonalData />;
        }
    };

    return (
        <div className="profile-page-wrapper">
            <div className="profile-header-banner">
                Личный кабинет
            </div>

            <div className="profile-content">
                <ProfileSidebar
                    activeSection={activeSection}
                    onSectionChange={handleSectionChange}
                    onLogout={handleLogout}
                />

                <div className="profile-main-content">
                    {renderActiveSection()}
                </div>
            </div>
        </div>
    );
};

export default ProfilePage;
